var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCheckCircleGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 32,
    viewBox: "0 0 34 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2305 32C26.067 32 33.2305 24.8366 33.2305 16C33.2305 7.16344 26.067 0 17.2305 0C8.39391 0 1.23047 7.16344 1.23047 16C1.23047 24.8366 8.39391 32 17.2305 32Z",
    fill: "#40C057"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4887 10.1045C25.3743 9.98918 25.2382 9.89762 25.0882 9.83513C24.9382 9.77265 24.7773 9.74048 24.6149 9.74048C24.4524 9.74048 24.2915 9.77265 24.1415 9.83513C23.9916 9.89762 23.8554 9.98918 23.741 10.1045L14.5718 19.2861L10.7195 15.4215C10.6007 15.3067 10.4604 15.2165 10.3068 15.1559C10.1531 15.0954 9.98903 15.0657 9.82388 15.0685C9.65874 15.0714 9.49577 15.1067 9.34429 15.1726C9.19281 15.2384 9.05578 15.3334 8.94102 15.4522C8.82627 15.571 8.73604 15.7113 8.67548 15.8649C8.61492 16.0186 8.58522 16.1827 8.58808 16.3478C8.59093 16.513 8.62629 16.6759 8.69213 16.8274C8.75797 16.9789 8.853 17.1159 8.97179 17.2307L13.6979 21.9568C13.8124 22.0722 13.9485 22.1638 14.0985 22.2262C14.2484 22.2887 14.4093 22.3209 14.5718 22.3209C14.7343 22.3209 14.8951 22.2887 15.0451 22.2262C15.1951 22.1638 15.3312 22.0722 15.4456 21.9568L25.4887 11.9138C25.6136 11.7985 25.7133 11.6586 25.7815 11.5029C25.8497 11.3473 25.8849 11.1791 25.8849 11.0092C25.8849 10.8392 25.8497 10.6711 25.7815 10.5154C25.7133 10.3597 25.6136 10.2198 25.4887 10.1045Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckCircleGreen);
export default __webpack_public_path__ + "static/media/icon-check-circle-green.f2a6f0945e347df1b1574d74242d76b8.svg";
export { ForwardRef as ReactComponent };